import { render, staticRenderFns } from "./EDrawerHistoricoAulaLancadaComplementar.vue?vue&type=template&id=36e55292&scoped=true"
import script from "./EDrawerHistoricoAulaLancadaComplementar.vue?vue&type=script&lang=js"
export * from "./EDrawerHistoricoAulaLancadaComplementar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e55292",
  null
  
)

export default component.exports